import React from 'react';
import styles from './loader.module.scss';

const Loader = () => <div className={styles.loader} />;

export default Loader;
